import { render } from "./UsageStatusSectionMenuSaihanCmp.vue?vue&type=template&id=b830a104&scoped=true"
import script from "./UsageStatusSectionMenuSaihanCmp.vue?vue&type=script&lang=js"
export * from "./UsageStatusSectionMenuSaihanCmp.vue?vue&type=script&lang=js"

import "../css/UsageStatusSectionSaihan.css?vue&type=style&index=0&id=b830a104&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src991838332/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/splats-mypage-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b830a104"]])

export default __exports__